export const tableImageSizeFactor = 0.5;

export const square2_Dimension = 204;
export const square4_Dimension = 276;
export const rect2_Dimension = 130;
export const rect4_Dimension = 258;
export const rect6_Dimension = 351;
export const rect8_Dimension = 468;
export const rect10_Dimension = 540;
export const round2_Dimension = 213;
export const round4_Dimension = 256;
export const round6_Dimension = 307;
export const round8_Dimension = 365;
export const round10_Dimension = 462;
export const seabed_Dimension = 130;